module.exports = __webpack_public_path__ + "img/pt2020-03.50269956.svg";